/** Inbox notification chime — plays WAV; respects Settings → inbox_sound. */
import chimeUrl from "../assets/sounds/inbox-chime.wav";

let sharedAudio = null;
let unlocked = false;
let lastPlayAt = 0;

const readUserPref = (key, fallback = true) => {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "{}");
    if (u[key] === undefined || u[key] === null) return fallback;
    return !(u[key] === 0 || u[key] === false || u[key] === "0" || u[key] === "false");
  } catch {
    return fallback;
  }
};

const getAudio = () => {
  if (!sharedAudio) {
    sharedAudio = new Audio(chimeUrl);
    sharedAudio.preload = "auto";
    sharedAudio.volume = 0.7;
  }
  return sharedAudio;
};

/** Call from a click/keydown so the browser allows later chimes. */
export const unlockInboxSound = () => {
  try {
    const audio = getAudio();
    audio.muted = true;
    const p = audio.play();
    if (p && typeof p.then === "function") {
      p.then(() => {
        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;
        unlocked = true;
      }).catch(() => {
        audio.muted = false;
      });
    } else {
      audio.pause();
      audio.currentTime = 0;
      audio.muted = false;
      unlocked = true;
    }
  } catch {
    /* ignore */
  }
};

const playFile = async (force = false) => {
  if (!force && !readUserPref("inbox_sound", true)) return false;
  const now = Date.now();
  if (!force && now - lastPlayAt < 700) return false;
  lastPlayAt = now;

  try {
    const audio = getAudio();
    audio.muted = false;
    audio.volume = 0.7;
    audio.currentTime = 0;
    await audio.play();
    unlocked = true;
    return true;
  } catch {
    return false;
  }
};

/** Soft chime for a new inbound customer message. */
export const playInboxChime = () => {
  playFile(false);
};

/** Preview when enabling the setting (uses the toggle click gesture). */
export const previewInboxChime = () => {
  unlockInboxSound();
  playFile(true);
};

export const isInboxSoundEnabled = () => readUserPref("inbox_sound", true);

export const isInboxSoundUnlocked = () => unlocked;

/** Attach once so the first user click unlocks audio for later WS chimes. */
export const bindInboxSoundUnlock = () => {
  const onGesture = () => {
    unlockInboxSound();
    window.removeEventListener("pointerdown", onGesture, true);
    window.removeEventListener("keydown", onGesture, true);
  };
  window.addEventListener("pointerdown", onGesture, true);
  window.addEventListener("keydown", onGesture, true);
  return () => {
    window.removeEventListener("pointerdown", onGesture, true);
    window.removeEventListener("keydown", onGesture, true);
  };
};
